import { Box, Drawer } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Icon } from '../icon';
import { BorderedCard } from '../styled-components';

export const Wrapper = styled(Drawer)``;

export const Header = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${(p) => p.theme.spacing(1)};
  padding: 0 0 ${(p) => p.theme.spacing(2)} 0;
`;

export const HeaderIcon = styled(Icon)`
  height: ${(p) => p.theme.spacing(3)};
  width: ${(p) => p.theme.spacing(3)};
  cursor: pointer;
`;

export const Content = styled(BorderedCard)`
  padding: 0;
  z-index: inherit;
  border: 0;
  border-radius: 0;
`;
